import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { AUTH_LOGOUT, MODAL_CLOSE } from '../../../../app/redux/actions';
import auth from '../../../../app/api/auth';
import { setToken } from '../../../../app/api/token';

export const ModalExpiringSessionId = 'ModalExpiringSession';

const ModalExpiringSession = ({
  mediaIsPhone,
  modalClose,
  id,
  isOpen,
  logout,
}) => {
  const scrollableAreaRef = useRef(null);

  useEffect(() => {
    let timeout;
    if (id === ModalExpiringSessionId) {
      if (isOpen) {
        timeout = setTimeout(() => {
          logout();
          modalClose();
        }, 90 * 1000);
      }
      return () => {
        clearTimeout(timeout);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, isOpen]);

  return (
    <Modal
      title="Attenzione"
      modalId={ModalExpiringSessionId}
      scrollableAreaRef={scrollableAreaRef}
      forceOpen
      compact
    >
      <ScrollableArea ref={scrollableAreaRef}>
        <Text type="h3.5" mb={8}>
          Stai ancora navigando il portale?
        </Text>
        <Text type="b5">
          La sessione di navigazione scade tra 90 secondi. <br />
          Continua a navigare oppure torna in Area Pubblica.
        </Text>
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="torna in area pubblica"
          fullsize={mediaIsPhone}
          onClick={() => {
            logout();
            modalClose();
          }}
        />
        <CTA
          type="primary"
          btnText="CONTINUA A NAVIGARE"
          fullsize={mediaIsPhone}
          onClick={() => {
            auth.refreshToken({}).then((res) => {
              const { data: { data = {} } = {} } = res;
              setToken(data);
            });
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalExpiringSession.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  id: PropTypes.string,
  isOpen: PropTypes.bool,
  // dispatch
  modalClose: PropTypes.func.isRequired,
  logout: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const { id, isOpen } = state.app.modal;
      return { id, isOpen };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      logout: () => dispatch({ type: AUTH_LOGOUT._REQUEST }),
    })
  ),
  withMediaQueries
)(ModalExpiringSession);
